import { css } from 'styled-system/css';

export const betslipStyle = {
	root: css({
		_mars: {
			smOnly: {
				color: 'black.1',
				boxShadowColor: 'betslip.shadow',
			},
			md: {
				boxShadow: '0px 0px 24px {colors.betslip.shadow}',
			},
			'&[data-float="true"]': {
				bottom: 'var(--appbar-height)',
				zIndex: 'var(--appbar-zindex)',
				md: {
					bottom: 0,
				},
			},
			'&[data-expand="false"]': {
				'& .bet-slip__header-info': {
					display: 'block',
				},
			},
			'&[data-type="quickbet"] .bet-slip__title': {
				fontSize: '12px',
			},
			'&[data-type="quickbet"] .bet-slip__header-info .btn--icon': {
				display: 'none',
			},
			'&[data-type="single"] .bet-slip__keypad .keypad': {
				mt: '9px',
			},
			'--scheduled-betting-bg': '{colors.booked.1_10}',
		},
	}),
	empty: css({
		base: {
			w: 'auto'
		},
		_mars: {
			w: 'auto',
			smOnly: {
				w: 'auto',
				transform: 'none',
				_ltr: {
					left: 0,
				},
				_rtl: {
					right: 0,
				},
			},
		},
	}),
	betslipContainer: css({
		base: {
			overflow: 'unset',
			borderTopRadius: 'inherit',
			borderBottomRadius: '0',
			'& .bet-slip-area > :last-child': {
				borderBottomRadius: 'var(--border-radius-lg)',
			},
		},
		_mars: {
			bgColor: 'var(--other-lv2)',
		},
	}),
	betslipScrollContainer: css({
		base: {
			display: 'block',
			overflowX: 'hidden',
			overflowY: 'auto',
		}
	}),
	notice: css({
		base: {
		},
		_mars: {
			color: 'black.2',
		}
	}),
	balance: css({
		_mars: {
			color: 'blackOpacity.100',
		}
	}),
	headerTitle: css({
		base: {
		},
	}),
	subTitleWrapper: css({
		base: {
			bgColor: 'var(--other-lv2)'
		}
	}),
	subTitle: css({
		base: {
			fontSize: '13px',
			fontWeight: '700',
			_ltr: {
				p: '6px 9px 6px 12px',
			},
			_rtl: {
				p: '6px 12px 6px 9px',
			},
		},
		_galaxy: {
			color: 'var(--p500)',
			bgColor: 'var(--p500-12)',
		},
		_mars: {
			color: 'brand.500_light',
			bgColor: 'primary.300_12',
		}
	}),
	betButton: css({
		_mars: {
			'&:not([data-disabled="true"])': {
				bgColor: 'secondary.500',
				color: 'whiteOpacity.100',
			},
			'&:not([data-disabled="true"]) .bet-slip__betting-amount': {
				color: 'whiteOpacity.100',
			},
		},
	}),
	floatBookButtonWrapper: css({
		base: {
			display: 'flex',
			justifyContent: 'flex-end',
			p: '9px 9px 0 9px',
		}
	}),
	footer: css({
		base: {
			p: '6px 9px 21px 9px',
			justifyContent: 'space-between',
		},
		_mars: {
			pb: '3px',
			columnGap: '12px',
			justifyContent: 'flex-end',
			flexWrap: 'wrap',
		},
	}),
	galaxyBetSetting: css({
		_mars: {
			display: 'none'
		}
	}),
	bottomFooter: css({
		base: {
			display: 'none',
		},
		_mars: {
			display: 'block',
			px: '9px',
		}
	}),
	textInfoMars: css({
		_galaxy: {
			display: 'none',
		},
		_mars: {
			fontSize: '12px',
		}
	}),
	textInfo: css({
		base: {
			flex: 0,
			whiteSpace: 'nowrap',
			fontWeight: '400'
		},
	}),
	textSecondary: css({
		base: {
			fontSize: '14px',
			fontWeight: '500',
		},
		_mars: {
			color: 'secondary.500',
		}
	}),
	textError: css({
		base: {
			color: 'status.negative',
		},
	}),
	checkbox: css({
		base: {
			display: 'flex',
			justifyContent: 'flex-end',
			width: '100%',
			'& .checkbox': {
				height: '36px',
			}
		},
	}),
	betSlipParlay: css({
		_mars: {
			borderBottom: '1px solid {colors.black.5}',
			bgColor: 'var(--s500)',
			'& .bet-slip__notice-number': {
				color: 'whiteOpacity.100',
				bgColor: '#EC6363',
			},
			'& .bet-slip__notice--warning::before': {
				bgColor: '#EC6363',
			},
		},
	}),
	betSlipSingle: css({
		_mars: {
			borderBottom: '1px solid {colors.black.5}',
			bgColor: 'var(--other-lv2)',
		}
	}),
	betSlipParlayMore: css({
		base: {
			color: 'brand.500_text',
		}
	}),
	parlayArea: css({
		base: {
			pt: 0,
		},
		_mars: {
			bgColor: 'var(--s600)',
		},
	}),
	betSlipParlayWrap: css({
		base: {
			mt: '9px',
		},
	}),
	odds: css({
		base: {
			fontSize: '16px',
			color: 'black.1',
			'&[data-status="change-down"]': {
				color: 'status.negative',
			},
			'&[data-status="change-up"]': {
				color: 'status.positive',
			},
		},
	}),
	oddsMinus: css({
		base: {
			color: 'status.negative',
		}
	}),
	oddsNormal: css({
		base: {
			color: 'black.1',
		}
	}),
	// use oddsBooster style
	oddsBoost: css({

		'& .ticket__odds span': {
			textDecoration: 'line-through',
			fontSize: '12px',
			color: 'blackOpacity.54',
			fontWeight: '400',
			_dark: {
				color: 'whiteOpacity.70',
			}
		},
	}),

	oddsBoostTag: css({
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '6px',
		border: '1px solid var(--special-08)',
		p: '0px 3px',
		mb: '3px',
		'& span': {
			fontSize: '16px',
			fontWeight: '700',
			color: 'var(--special-08)',
		}
	}),
	betInput: css({
		_mars: {
			'&[data-disabled="true"]': {
				opacity: 0.5,
			}
		}
	}),
	quickStakeButton: css({
		_mars: {
			border: '1px solid {colors.black.5}',
		}
	}),
	// booked bet
	bookedBetInput: css({
		base: {
			bgColor: 'white.2',
			border: '1px solid {colors.booked.2}',
		}
	}),
	bookedSubmitButton: css({
		base: {
			bgColor: 'booked.4',
			color: 'whiteOpacity.100',
			_hover: {
				bgColor: 'booked.3',
			}
		},
	}),
	bookedQuickStakeButton: css({
		base: {
			bgColor: 'booked.2',
			color: 'whiteOpacity.100',
			lg: {
				_hover: {
					bgColor: 'booked.3',
				}
			}
		},
	}),

	// Modal
	modalHeader: css({
		base: {
			display: 'flex',
			height: '48px',
			p: '3px',
			alignContent: 'center',
			fontSize: '16px',
			fontWeight: '700',
			borderTopRadius: 'inherit',
			_ltr: {
				pr: '6px',
			},
			_rtl: {
				pl: '6px',
			},
			md: {
				p: '9px',
				_ltr: {
					pl: '12px',
				},
				_rtl: {
					pr: '12px',
				},
			},
			'& .icon--arrow-left': {
				width: '20px',
				height: '20px',
			},
		},
		_mars: {
			color: 'white',
			bgColor: 'betslip.parlayHeaderBg',
			'& .btn--text': {
				color: 'white',
				bgColor: 'betslip.parlayHeaderButtonBg',
			}
		}
	}),
	modalHeaderTitle: css({
		base: {
			flex: 1,
			display: 'flex',
			alignItems: 'center',
		},
	}),
	modalHeaderText: css({
		base: {
			_ltr: {
				ml: '6px',
			},
			_rtl: {
				mr: '6px',
			},
		},
	}),
	modalHeaderBadge: css({
		base: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			minWidth: '15px',
			height: '15px',
			rounded: '15px',
			fontWeight: '400',
			fontSize: '12px',
			px: '3px',
			_ltr: {
				ml: '6px',
			},
			_rtl: {
				mr: '6px',
			},
		},
		_mars: {
			color: 'white',
			bgColor: '#FF3333',
		}
	}),
	modalHeaderTools: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			gap: '12px',
		},
	}),
	backButton: css({
		base: {
			w: '30px',
			h: '30px',
			m: 'auto 0',
			md: {
				display: 'none',
			},
		},
		_mars: {
			color: 'white'
		}
	}),
	collapseButton: css({
		'--mars-color': { base: '{colors.whiteOpacity.100}', _dark: '{colors.whiteOpacity.54}' },
		base: {
			_mdBelow: {
				display: 'none',
			}
		},
		_mars: {
			color: 'var(--mars-color) !important',
		}
	}),
	// when activeFloatBetSlip
	floatBetslipSwitch: css({
		base: {
			p: '6px',
			w: '100%',
			borderTop: 'none',
			bg: 'none',
			// borderRadius: 'inherit',
			md: {
				p: '12px',
			}
		},
		_mars: {
			bgColor: 'var(--other-lv2)',
		}
	}),
	asideBetslipSwitch: css({
		base: {
			p: '9px'
		},
		_mars: {
			bgColor: 'var(--s800)'
		}
	}),
	// if isIndependentMode || activeFloatBetSlip
	singleAreaContainer: css({
	}),
	// if activeFloatBetSlip
	singleAreaFloat: css({
		_mars: {
			'& .bet-slip__coin': {
				rounded: '6px',
				m: '6px',
				md: {
					m: '12px',
				}
			},
			'& .single-area-wrap': {
				md: {
					rounded: '9px',
				}
			},
		}
	}),
	independentParlayFail: css({
		base: {
			m: 0,
			rounded: 0,

			md: {
				m: 0,
			},

			'& .icon': {
				opacity: 1,
			}
		},
		// '.main-wrap__aside &': {
		// 	_mars: {
		// 		rounded: 'var(--border-radius-lg)!',
		// 		mb: '6px',
		// 	}
		// }
	}),
	betslipIndependent: css({
		base: {
			h: 'calc( 100% - var(--header-height) - var(--page-header-height))',
			maxH: 'calc( 100% - var(--header-height) - var(--page-header-height))',
			'& .bet-slip__header': {
				borderBottom: 'none'
			},
			md: {
				h: 'auto',
				maxH: '80%',
			},

		},
	}),
	// when activeFloatBetSlip
	betslipModal: css({
		base: {
			zIndex: 'var(--confirm-bet-zindex)',
			mb: '39px',
			'&[data-expand="false"]': {
				display: 'none',
			},
			'& .bet-slip__container > .scrollbar': {
				flex: 1,
			},
			md: {
				width: '600px',
				transform: 'translateX(-50%)',
				maxH: 'calc(100vh - 48px - 140px)', // 參考 modal.scss
				_ltr: {
					transform: 'translateX(-50%)',
				},
				_rtl: {
					transform: 'translateX(50%)',
				},
			},
			_mdBelow: {
				top: 0,
				maxH: '100vh',
				overscrollBehavior: 'contain',
				rounded: 0,
				mb: '0',
			},
		},
	}),
	betslipAside: css({
		base: {
			position: 'initial',
			transform: 'none',
			boxShadow: 'none',
			maxH: 'none!',
			w: '100%',
			borderRadius: 'var(--border-radius-lg)',
			'& .bet-slip-area': {
				borderRadius: 'inherit',
				borderBottomRadius: 0,
				flex: 1,
				p: '6px 6px 0 6px',
				borderTopRadius: 'inherit',

				'& .single-area-wrap': {
					overflow: 'hidden',
				},

				'& > :first-child': {
					borderTopRadius: 'inherit',
				}
			},
			'& .bet-slip__quick-bet-stake': {
				_ltr: {
					ml: 'auto',
				},
				_rtl: {
					mr: 'auto',
				},
			},
		},
		_mars: {
			'& .bet-slip-area': {
				bgColor: 'var(--s800)',
			},
			'& .bet-slip__parlay-fail': {
				rounded: 'var(--border-radius-lg)',
				mb: '6px',
			},
			'& .single-area-wrap': {
				roundedTop: 'var(--border-radius-lg)',
				color: 'red',
			},
		}
	}),
	betslipAsideIndependent: css({
		base: {
			borderRadius: 'unset',
			'& .bet-slip-area': {
				borderTopRadius: 'unset',
			},

			'& .single-area-wrap  > :first-child': {
				borderTopRadius: 'var(--border-radius-lg)',
			},
			'& .single-area-wrap  > :last-child': {
				borderBottomRadius: 'var(--border-radius-lg)',
			},

		},
	}),
	// when activeFloatBetSlip
	parlayModeWarning: css({
		base: {
			m: '6px',
			rounded: '6px',
			md: {
				m: '12px',
			},
		},
	}),
	parlayWarning: css({
		base: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			p: '9px',
			fontSize: '14px',
			'& .icon': {
				_ltr: {
					mr: '6px',
				},
				_rtl: {
					ml: '6px',
				},
			}
		},
		_mars: {
			bgColor: 'betslip.parlayWarningBg',
			color: 'betslip.parlayWarningText',
			'& .icon': {
				color: 'secondary.500',
			}
		},
	}),
	// when activeFloatBetSlip
	singleAreaWrap: css({
		_mars: {
			m: '6px',
			rounded: '6px',
			bgColor: 'var(--other-lv2)',
			overflow: 'hidden',
			md: {
				m: '12px',
			},
			'& > *:last-child': {
				borderBottom: 'none',
			}
		},
	}),
	// when activeFloatBetSlip
	parlayAreaWrap: css({

		_mars: {
			maxH: '50vh',
			overflowY: 'auto',
			overscrollBehavior: 'contain',
			_scrollbar: {
				width: '8px',
				bgColor: 'var(--s600)',
			},
			_scrollbarThumb: {
				bgColor: 'var(--s800)',
				border: '1px solid var(--s600)',
				rounded: '6px',
			},
			_scrollbarTrack: {
				bgColor: 'var(--s600)',
			},
		},
	}),
	// when activeFloatBetSlip
	parlayModeBottomFixed: css({
		base: {
			pos: 'relative',
			flex: '0 0 auto',
			overflow: 'hidden',
			boxShadow: '0px -12px 12px {colors.betslip.shadow}',
			bgColor: 'var(--other-lv2)',
			_mdBelow: {
				rounded: '6px 6px 0 0',
			},
		},
	}),
	// when activeFloatBetSlip
	parlayToggleButton: css({
		base: {
			display: 'none'
		},
		_mars: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: '42px',
			color: 'brand.500_light',
			bgColor: 'var(--s500)',
			p: '12px',
			fontSize: '13px',
			cursor: 'pointer',
			'& .icon': {
				width: '20px',
				height: '20px',
				mx: '3px',
				transform: 'rotate(180deg)',
				transition: 'transform 200ms ease-in',
			},
			_active: {
				'& .icon': {
					transform: 'rotate(0deg)',
				}
			}
		}
	}),
	// when activeFloatBetSlip
	parlayModeFooter: css({
		base: {
			bgColor: 'var(--other-lv2)',
		}
	}),
	asideTrashCanIcon: css({
		base: {
			flex: '0 0 39px',
			w: '39px',
			h: '39px',
			'& svg': {
				w: '32px',
			},
			_ltr: {
				mr: '10px',
			},
			_rtl: {
				ml: '10px',
			}
		}, 
		_mars: {
			bgColor: 'var(--s800)',
		},
	}),
	availableFunds: css({
		base: {
			fontSize: '12px',
			fontWeight: '500',
			lineHeight: '15px',
			_ltr: {
				textAlign: 'right',
			},
			_rtl: {
				textAlign: 'left',
			},
		},
		_mars: {
			display: 'none'
		}
	}),
	cleanAllButton: css({
		base: {
			'--mars-bg-color': { base: 'colors.whiteOpacity.30', _dark: 'var(--s800)' },
			'--mars-color': { base: 'white', _dark: 'colors.whiteOpacity.100' },
			h: '26px',
			borderRadius: 'var(--border-radius-md)',
			cursor: 'pointer',
			display: 'flex',
			gap: '3px',
			alignItems: 'center',
			justifyContent: 'center',
			p: '6px',
			_mdBelow: {
				bgColor: 'inherit',
				color: 'var(--other-lv1-80)',
				'& .clean-text': {
					display: 'none'
				},
				'& .icon': {
					h: '24px',
					w: '24px'
				}
			},
			'& .icon': {
				h: '20px',
				w: '20px'
			}
		},
		_mars: {
			color: 'var(--mars-color)',
			bgColor: 'var(--mars-bg-color)',
		}
	}),
	cleanAllText: css({
		base: {
			fontSize: '14px',
			fontWeight: '500',
			
		}
	}),
	asideStickyFooter: css({
		base: {
			position: 'sticky',
			bottom: '0',
			backgroundColor: 'var(--other-lv2)',
			zIndex: '1',
			borderRadius: '0 0 9px 9px'
		},
	}),
	hasTicket: css({
		_mars: {
			_mdBelow: {
				width: '100%',
				transform: 'none',
				_ltr: {
					left: '0',
				},
				_rtl: {
					right: '0',
				},
			},
		},
		// _galaxy: {
		// 	_mdBelow: {
		// 		width: 'calc(100% - 24px)',
		// 		left: '50%',
		// 		transform: 'translateX(-50%)',
		// 	}
		// }
	})
};